/**
 * @class directive_v3sBorder
 * @memberOf v3sWbtPlayerApp:page:elements
 * @description
 * Fügt dem HTML-Element die entsprechende Klasse für den angegebenen Border typ an 
 */

angular.module('v3sWbtPlayerApp').directive('v3sBorder', function () {
    return {
        restrict: 'A',
        link: function (scope, element, attrs) {
            element.addClass('border-' + attrs.v3sBorder);
        }
    }
});

/**
 * Setzt die Borderbreite für das element
 * @class directive_v3sBorderWidth
 * @memberOf v3sWbtPlayerApp:page:elements
 */

angular.module('v3sWbtPlayerApp').directive('v3sBorderWidth', function () {
    return {
        restrict: 'A',
        link: function (scope, element, attrs) {
            element.css({
                'border-style' : 'solid',
                'border-width': attrs.v3sBorderWidth + 'px'
            });
        }
    }
});

/**
 * Setzt die Borderfarbe für das element
 * @class directive_v3sBorderColor
 * @memberOf v3sWbtPlayerApp:page:elements
 */

angular.module('v3sWbtPlayerApp').directive('v3sBorderColor', function () {
    return {
        restrict: 'A',
        link: function (scope, element, attrs) {
            element.css('border-color', attrs.v3sBorderColor );
        }
    }
});
